// extracted by mini-css-extract-plugin
export default {"shadowCustomisations":"ShadowOptions_shadowCustomisations__y9tz0","visible":"ShadowOptions_visible__4dXdJ"};